import React from "react";
import PlayCircleFilledIcon from "@mui/icons-material/PlayCircleFilled";
import classes from "./VideoCard.module.scss";

type VideoCardProps = {
  videoKey: string;
  thumbnailUrl: string;
  title: string;
  duration: string;
  onPlay: (videoKey: string) => void;
};

/** Renders a video tutorial card with a thumbnail, play button overlay, title and duration.
 * Clicking it opens the video in a modal player (see VideoPlayerModal). */
const VideoCard = ({
  videoKey,
  thumbnailUrl,
  title,
  duration,
  onPlay,
}: VideoCardProps) => {
  return (
    <div className={`card ${classes.card}`}>
      <div className={classes.thumbnailWrapper} onClick={() => onPlay(videoKey)}>
        {thumbnailUrl && (
          <img className="card-img-top" src={thumbnailUrl} alt={title} />
        )}
        <div className={classes.playButton}>
          <PlayCircleFilledIcon />
        </div>
      </div>
      <div className="card-body">
        <h5 className="card-title">{title}</h5>
        <p className="card-text">{duration}</p>
      </div>
    </div>
  );
};

export default VideoCard;
